import { AccordionSummary, IconButton, Typography } from "@mui/material";
import ChevronDownIcon from "assets/icons/ChevronDown";

interface CategoryAccordionSummaryProps {
  title: string;
}

const CategoryAccordionSummary = ({
                                    title,

                                  }: CategoryAccordionSummaryProps) => (
  <AccordionSummary
    sx={{
      px: 1.5,
      py: 1,
      borderRadius: 3,
      '&.Mui-expanded': {
        backgroundColor: 'grey.400',
        '& .MuiTypography-root': {
          color: 'black.100',
        },
      },
      '& .MuiAccordionSummary-expandIconWrapper': {
        transform: "rotate(-90deg)",
      },
      '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: "rotate(0)",
        '& > .MuiButtonBase-root': {
          color: 'primary.main',
        },
      },
    }}
    expandIcon={
      <IconButton>
        <ChevronDownIcon sx={{
          width: 20,
          height: 20,
        }} />
      </IconButton>
    }
  >
    <Typography variant={'h5'} sx={{ color: 'grey.200' }}>
      {title}
    </Typography>
  </AccordionSummary>
);

export default CategoryAccordionSummary;
